import {entityList, executeCall} from './CallService';


export const bootstrapList = async(dbValues) => {
    return entityList("bootstrap", dbValues);
}

export const operDDL = async() => {
    const action = "oper.ddl";
    return await executeCall(action);
}

export const operBootstrapDDL = async() => {
    const action = "oper.bootstrap.ddl";
    return await executeCall(action);
}
